/**
 * @generated SignedSource<<45b36649fd99b517f5a082d328b72a64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MailingListsViewMailingListsQuery$variables = Record<PropertyKey, never>;
export type MailingListsViewMailingListsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MailingListList_query">;
};
export type MailingListsViewMailingListsQuery = {
  response: MailingListsViewMailingListsQuery$data;
  variables: MailingListsViewMailingListsQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MailingListsViewMailingListsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "MailingListList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MailingListsViewMailingListsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MailingList",
        "kind": "LinkedField",
        "name": "mailingLists",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mailingListIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscribedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unsubscribedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archivedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1731e6496eae6ea16b5ef3805662827c",
    "id": null,
    "metadata": {},
    "name": "MailingListsViewMailingListsQuery",
    "operationKind": "query",
    "text": "query MailingListsViewMailingListsQuery {\n  ...MailingListList_query\n}\n\nfragment MailingListList_query on Query {\n  mailingLists {\n    id\n    mailingListIdentifier\n    name\n    description\n    subscribedCount\n    unsubscribedCount\n    createdAt\n    archivedAt\n  }\n}\n"
  }
};

(node as any).hash = "52465cd629b3df88f9f217ff82a2273e";

export default node;
